import pImg4 from "../images/case/case1.jpg";
import pImg5 from "../images/case/case2.jpg";
import pImg6 from "../images/case/case3.jpg";
import tImg1 from "../images/icons/icon_php.svg";
import tImg2 from "../images/icons/icon_laravel.svg";
import react from "../images/icons/icon_react_js.svg";
import haramaynhotels from '../images/icons/haramayn.PNG'
import flutter from "../images/icons/flutter-svgrepo-com.svg";

const Project = [
  {
    Id: "1",
    pImg: pImg4,
    title: "Back Office Travel Agent",
    shorttitle: " Back Office Travel Agent",
    singlepagedescription:
      "This system, a renowned travel agency specializing in Hajj and Umrah services, recognized the need to modernize its operations to handle increasing demand and ensure seamless service delivery. To achieve this, they developed the Super Admin System, a centralized platform designed to streamline administrative tasks, enhance operational efficiency, and provide real-time insights into various facets of the business.",
    slug: "Back-Office",
    sub: "Computer Software",
    Industry: "Computer software",
    Country: "United Kingdom",
    Technologies: [tImg1, tImg2, react],
    reqdecs:'Travel Back Office streamlines operations by centralizing the management of bookings, invoices, and customer data. It enables travel agencies to automate workflows, improve efficiency, and maintain accurate records across all services.',
    requirements: [
      "User Management",
      "Package Management",
      "Customer Relationship Management (CRM)",
      "Reporting and Analytics",
      "Booking history and invoice download",
      "Payment Gateway Integration",
      "Hotels Booking",
      "Transfers Booking",
      "Flight Bookings",
      "Visa Booking",
      "HRMS",
      "Booking and Reservation System",
      "Commission Tracking",
      "Lead Management",
    ],
    description:
      "Travel Back Office is designed to streamline and automate daily operations for travel agencies. It allows seamless management of bookings, invoices, and customer information from a centralized system.",
    conclusion:
      "The implementation of the Back Office Travel Agent marked a significant milestone in the company's digital transformation journey. By centralizing operations and automating key processes, the system enhanced efficiency, reduced manual errors, and improved customer satisfaction. The modular design ensures scalability, allowing the travel service provider to adapt to future business needs and technological advancements. Overall, the Super Admin System has positioned the organization to better serve its clients and maintain a competitive edge in the travel industry.",
  },
  {
    Id: "2",
    pImg: pImg5,
    title: "Mahatal Al Alam",
    shorttitle: "Mahatal Al Alam Mobile App",
    singlepagedescription:
      "Mahatal Al Alam is a comprehensive mobile application designed to simplify travel logistics for users by providing a seamless interface for hotel bookings, transportation services, and package deals. Developed for Android and iOS, the app primarily serves international and regional travelers with a focus on convenience, speed, and user experience.",
    slug: "Mahatal-Al-Alam",
    sub: "Mobile App",
    Industry: "App Development",
    Country: "Birmingham, UK",
    Technologies: [flutter, tImg2],
     reqdecs:'Mahatal Al Alam is a mobile app designed for effortless hotel and transfer bookings. It provides users with fast, intuitive access to global accommodation and transport options.',
    requirements: [
      "Hotel Search & Booking System",
      "Advanced Filter & Sorting Options",
      "Hotel Detail Pages",
      "Transfer Booking ",
      "Package Booking ",
      "Dynamic Pricing & Service Breakdown",
      "Integrated Payment Gateway",
      "Mobile-Responsive & Cross-Platform Support",
      "Security & Privacy Compliance",
      "Push Notifications & Alerts",
    ],

    description:
      "Mahatal Al Alam is a mobile app for seamless hotel and transfer bookings. It offers quick, user-friendly access to accommodations and transport services worldwide.",
    conclusion:
      "Mahatal Al Alam successfully streamlines the travel experience into a single mobile app, bringing together hotel, transfer, and package bookings under one platform. Its modern design and robust feature set address the needs of travelers seeking reliability and simplicity. The app not only enhances user satisfaction but also positions the service provider as a trusted name in the digital travel and hospitality space.",
  },
  {
    Id: "3",
    pImg: pImg6,
    title: "Haramayn Hotels",
    shorttitle: "Haramayn Hotels: Digital Hospitality for Pilgrims",
    singlepagedescription:
      "Haramayn Hotels is a specialized travel platform for booking hotels in Makkah and Madinah. It primarily serves pilgrims traveling for Hajj and Umrah, offering a smooth and reliable booking experience. The platform highlights properties close to the holy sites, ensuring convenience and comfort. With user-friendly navigation and dedicated customer support, it simplifies travel planning for spiritual journeys.",
    slug: "Haramayn-Hotels",
    sub: "Booking website",
    Industry: "Booking website",
    Country: "Saudia Arabia",
    Technologies: [react, tImg2],
     reqdecs:'Haramayn Hotels is a dedicated travel platform for booking accommodations in Makkah and Madinah. It caters to Hajj and Umrah pilgrims by offering easy reservations, prime hotel locations, and dependable customer support.',
    requirements: [
      "Hotel search with filters (location, distance from Haram, price, rating)",
      "View hotel details (photos, amenities, reviews)",
      "Real-time room availability",
      "Booking and payment gateway integration",
      "Booking history and invoice download",
      "Multi-language support (Arabic & English)",
      "Currency Conversion",
      "Clean, mobile-responsive design",
      "Easy-to-use booking form",
    ],
singlepageimage:haramaynhotels,
    description: 
      "Haramayn Hotels is a travel platform for booking hotels in Makkah and Madinah, focused on serving Hajj and Umrah pilgrims with easy booking, prime locations, and reliable support.",
    conclusion:
      "Haramayn Hotels positions itself as a comprehensive travel solution for pilgrims, combining accommodation bookings with additional services. While the platform offers a user-friendly experience and a range of services, addressing technical and SEO-related challenges could further enhance its digital footprint. Optimizing site speed, improving mobile responsiveness, and integrating multilingual support would better cater to its global user base. Strengthening local SEO for key pilgrimage seasons like Hajj and Umrah can also drive more targeted traffic. Additionally, enhancing the backend for scalability and smoother booking processes would position Haramayn Hotels as a more robust and reliable platform in the competitive travel-tech space.",
  },
];

export default Project;
